import React from "react";

export default function InitiativeCounter({ i }) {
  return (
    <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 mb-0 text-xs bg-primary text-white font-medium w-6 h-6 flex justify-center items-center rounded-full group-hover:bg-white group-hover:text-primary shadow-sm shadow-slate-500">
      {i + 1}
    </div>
  );
}
